function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import ApiClient from './infrastructure/api/api-client';
import TranslationManager from './infrastructure/translation-manager';
import SiteLinkManager from './infrastructure/site-link-manager';
import ShopMenuLinkManager from './infrastructure/shop-menu-link-manager';
import ConfigurationManager from './infrastructure/configuration-manager';
import { ChooseYourProductConstants, TranslationKeys, FeatureFlags, Events, Ids } from './infrastructure/const';
import ShopInitializationUtils from './utilities/shop-initialization-utils';
import ModalDialog from './components/modal-dialog';
import ErrorDetails from './components/error-details';
import NavigationManager from './infrastructure/navigation-manager';
import Logger from '../../../../wdh-foundation/wdh-logger/wdh-logger';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import uuidv1 from 'uuid/v1';
import { EventTypes } from './infrastructure/const';
var EventBus = window.DGS.Event.getInstance();

/**
 * Initialization component responsible for setting up client library, translation manager, configuration manager and sitelink manager
 * Additionally the component adds the level 3 menu items to the menu
 *
 * This component is required on all pages with other b2b shop components
 * @memberOf module:wdh-feature-b2b
 */
var WDHFeatureB2BShopInitializationSpot = /*#__PURE__*/function (_WDHComponent) {
  function WDHFeatureB2BShopInitializationSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wdh-feature-b2b-shopinitializationspot';
    _classCallCheck(this, WDHFeatureB2BShopInitializationSpot);
    return _callSuper(this, WDHFeatureB2BShopInitializationSpot, [className]);
  }

  /**
   * Check if a shop menu items should be shown or not.
   * If the menu item has feature flags set, the user needs to have access to those feature flags for the menu item to be shown
   * @param {Array} shopMenuLinkItem  The shop menu items to check
   * @returns {bool}                  True if the shop menu item shold be shown, else false
   * @private
   */
  _inherits(WDHFeatureB2BShopInitializationSpot, _WDHComponent);
  return _createClass(WDHFeatureB2BShopInitializationSpot, [{
    key: "init",
    value: function init(component) {
      // Load Configuration
      ConfigurationManager.loadConfiguration(document.getElementById('B2BConfiguration'));

      // Load Translations
      TranslationManager.loadAllTranslations(document.getElementById('B2BShopAllTranslations'));

      // Load SiteLinks
      SiteLinkManager.loadSiteLinks(document.getElementById('B2BShopSiteLinks'));

      // Load ShopMenuLinks
      ShopMenuLinkManager.loadShopMenuLinks(document.getElementById('B2BShopMenuLinks'));

      // Load Client Library
      var sessionDetails = JSON.parse(document.getElementById('B2BSessionDetails').innerHTML);
      ConfigurationManager.setTokenDetails(sessionDetails.token);
      ConfigurationManager.setUserId(sessionDetails.user);
      ConfigurationManager.setCustomerGroupId(sessionDetails.customergroupid);
      ConfigurationManager.setUserCanSeePrices(sessionDetails.canseeprices);
      if (!ConfigurationManager.isConfigured()) {
        return;
      }
      var config = {
        endpoint: ConfigurationManager.getShopServiceEndPoint(),
        token: sessionDetails.token,
        tokenKeepAliveUrl: '/api/shop/keepAlive',
        tokenKeepAliveDelay: 60000,
        language: sessionDetails.currentlanguage,
        mock: ShopInitializationUtils.getMockValue(),
        telemetry: ConfigurationManager.getTelemetry()
      };
      ApiClient.setToken(config.token);
      this.translations = {
        shortcutsLabel: TranslationManager.getTranslation(TranslationKeys.SHORTCUTSLABEL)
      };

      // Load menues
      // this loads a dynamic menu of products which we are not using at this time.  we may want to remove at a later date if not planned for future release.
      // this.loadMenues();

      EventBus.trigger(EventTypes.SHOP_INIT_READY);
      window.shopInitReady = true; // needed for components that come after event.

      ReactDOM.render(/*#__PURE__*/React.createElement(ShopInitialization, {
        className: this.className
      }), component.querySelector('.component-content'));
    }

    /**
     * Load the menu (level 3) from the client library and from Sitecore
     * Meke sure that the menu is correct, before sending it to the common menu
     */
  }, {
    key: "loadMenues",
    value: function loadMenues() {
      var _this = this;
      var promises = [];

      // Show bulk orders if featureflag is set
      if (ConfigurationManager.isFeatureFlagEnabled(FeatureFlags.CAN_SEE_BULK_ORDERS) === true) {
        promises.push(ApiClient.category.getBulkOrderCategories(true));
      }
      if (ConfigurationManager.isFeatureFlagEnabled(FeatureFlags.CAN_SEE_PATIENT_ORDERS) === true) {
        promises.push(ApiClient.category.getClientOrderCategories());
      }
      if (promises.length > 0) {
        Promise.all(promises).then(function (response) {
          var addMenuItemsMessage = {
            menuItems: []
          };
          if (ConfigurationManager.isFeatureFlagEnabled(FeatureFlags.CAN_SEE_BULK_ORDERS) === true) {
            var bulkOrdermenuitems = response[0];
            WDHFeatureB2BShopInitializationSpot.divideMenuItemsIntoColumns(bulkOrdermenuitems);
            var addMenuItemsBulkOrders = ShopInitializationUtils.buildMenuItemsEventBusMessage(bulkOrdermenuitems, true);
            addMenuItemsMessage.menuItems = addMenuItemsMessage.menuItems.concat(addMenuItemsBulkOrders);
          }
          if (ConfigurationManager.isFeatureFlagEnabled(FeatureFlags.CAN_SEE_PATIENT_ORDERS) === true) {
            var patientordermenuitems = ConfigurationManager.isFeatureFlagEnabled(FeatureFlags.CAN_SEE_BULK_ORDERS) === true ? response[1] : response[0];
            var addMenuItemspatientOrders = ShopInitializationUtils.buildMenuItemsEventBusMessage(patientordermenuitems, false);
            addMenuItemspatientOrders = {
              title: TranslationManager.getTranslation(TranslationKeys.SHARED_CLIENT_ORDERS_HEADER),
              menuItems: addMenuItemspatientOrders
            };
            addMenuItemsMessage.menuItems = addMenuItemsMessage.menuItems.concat(addMenuItemspatientOrders);
          }
          var shopMenuLinks = _this.getShopMenuLinks();
          addMenuItemsMessage.menuItems.push(shopMenuLinks);

          // Send message to all menues
          EventBus.trigger(Events.ADD_MENUITEMS, addMenuItemsMessage);
        });
      }
    }

    /**
     * Get the shop menu items from Sitecore and create the menu items structure
     * @returns {Array}   The created menu items
     */
  }, {
    key: "getShopMenuLinks",
    value: function getShopMenuLinks() {
      var shopMenuLinks = ShopMenuLinkManager.getShopMenuLinks();
      var newMenuItem = {
        title: this.translations.shortcutsLabel,
        column: 3,
        menuItems: [],
        url: ''
      };
      shopMenuLinks.forEach(function (shopMenuLinkItem) {
        if (WDHFeatureB2BShopInitializationSpot.showShopMenuLink(shopMenuLinkItem)) {
          newMenuItem.menuItems.push({
            title: shopMenuLinkItem.title,
            url: shopMenuLinkItem.url
          });
        }
      });
      return newMenuItem;
    }
  }], [{
    key: "divideMenuItemsIntoColumns",
    value:
    /**
    * Divides all menuItems into columns from left to right
    *
    * @param {Array} menuItems  The menuItems that needs to be divided into columns
    * @private
    */
    function divideMenuItemsIntoColumns(menuItems) {
      var currentColumn = 0;
      var currentColumnItemCount = 0;
      for (var i = 0; i < menuItems.length; i += 1) {
        // Strip submenues if more than MAX_MENUITEMS_PER_COLUMN
        if (menuItems[i].children.length > ChooseYourProductConstants.MAX_MENUITEMS_PER_COLUMN) {
          var lastIndex = ChooseYourProductConstants.MAX_MENUITEMS_PER_COLUMN - 1;
          menuItems[i].children.splice(0, menuItems[i].children.length - lastIndex);

          // Special menu node that navigates to whole category (with no family selected)
          var moreMenuItem = {
            title: TranslationManager.getTranslation(TranslationKeys.SHARED_MORE),
            id: Ids.DEFAULT_ID
          };
          menuItems[i].children.push(moreMenuItem);
        }
        var maxItems = ChooseYourProductConstants.MAX_MENUITEMS_PER_COLUMN;
        if (currentColumnItemCount > 0 && currentColumnItemCount + menuItems[i].children.length + 1 + (currentColumnItemCount === 0 ? 0 : 1) > maxItems) {
          // Move to next column
          currentColumn += 1;
          currentColumnItemCount = 0;
        }
        menuItems[i].column = currentColumn;
        currentColumnItemCount += menuItems[i].children.length + 1 + (currentColumnItemCount === 0 ? 0 : 1);
      }
    }
  }, {
    key: "showShopMenuLink",
    value: function showShopMenuLink(shopMenuLinkItem) {
      var showShopMenuLink = false;
      if (shopMenuLinkItem.featurekeys.length === 0) {
        showShopMenuLink = true;
      } else {
        shopMenuLinkItem.featurekeys.forEach(function (featurekey) {
          if (ConfigurationManager.isFeatureFlagEnabled(featurekey) === true) {
            showShopMenuLink = true;
          }
        });
      }
      return showShopMenuLink;
    }
  }]);
}(WDHComponent);
export default WDHFeatureB2BShopInitializationSpot;

/**
 * @param props
 * @memberof module:wdh-feature-b2b
 * @example
 * <ShopInitialization />
 * @private
 */
var ShopInitialization = /*#__PURE__*/function (_React$Component) {
  function ShopInitialization(props) {
    var _this2;
    _classCallCheck(this, ShopInitialization);
    _this2 = _callSuper(this, ShopInitialization, [props]);
    _this2.state = {
      globalError_showPopup: false,
      globalError_error: {},
      sessionExpired: false
    };

    /**
     * Translation texts for the component
     * @private
     * @type {Object}
     */
    _this2.translations = {
      okButton: TranslationManager.getTranslation(TranslationKeys.SHARED_OK),
      mainText: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION),
      sessionExpiredTitle: TranslationManager.getTranslation(TranslationKeys.SHARED_SESSION_EXPIREDTITLE),
      sessionExpiredText: TranslationManager.getTranslation(TranslationKeys.SHARED_SESSION_EXPIREDTEXT),
      sessionExpiredButtonText: TranslationManager.getTranslation(TranslationKeys.SHARED_SESSION_EXPIREDBUTTONTEXT)
    };
    return _this2;
  }
  _inherits(ShopInitialization, _React$Component);
  return _createClass(ShopInitialization, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      ApiClient.initErrorHandling(function (err) {
        _this3.setState({
          globalError_showPopup: true,
          globalError_error: err
        });
      });
      this.keepAliveInterval = setInterval(this.tokenKeepAlive, 60000);
      if (window.location.host.indexOf('local.cas.dgs.com') >= 0 && window.location.port === '3000') {
        var canvas = document.getElementById('localCanvas');
        var ctx = canvas.getContext('2d');
        ctx.font = '30px Comic Sans MS';
        ctx.fillStyle = 'pink';
        ctx.textAlign = 'center';
        ctx.rotate(-45 * Math.PI / 180);
        ctx.fillText('local proxy', 0, 120);
      }
    }

    /**
     * @private
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.keepAliveInterval);
    }
  }, {
    key: "showError",
    value: function showError(event) {
      event.preventDefault();
    }
  }, {
    key: "hideError",
    value: function hideError() {
      this.setState({
        globalError_showPopup: false
      });
    }
  }, {
    key: "sessionExpiredClicked",
    value: function sessionExpiredClicked() {
      NavigationManager.navigate(window.location.href);
    }
  }, {
    key: "tokenExpirationFailedCallback",
    value: function tokenExpirationFailedCallback(callback) {
      this.tokenExpirationFailedCallback = callback;
    }
  }, {
    key: "tokenKeepAlive",
    value: function tokenKeepAlive() {
      var _this4 = this;
      var configuration = {
        tokenKeepAliveUrl: '/api/shop/keepAlive',
        tokenKeepAliveDelay: 60000
      };
      var config = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Correlation-Id': uuidv1()
        }
      };
      if (configuration.tokenKeepAliveUrl === undefined) {
        console.warn("[".concat(new Date().toISOString(), "] Keep alive not configured."));
        return;
      }
      var url = configuration.tokenKeepAliveUrl;
      Logger.info("[".concat(new Date().toISOString(), "] Keep alive"));
      axios.post(url, null, config).then(function (response) {
        if (response.status === 200) {
          var data = response.data;
          if (data !== undefined) {
            var token = data.Token;
            if (token !== undefined) {
              Logger.info("[".concat(new Date().toISOString(), "] Token updated ").concat(token));
              ApiClient.setToken(token);
            }
          }
        } else if (response.status === 202) {
          // do nothing, server didn't decided yet to give you a new token, so keep trying...
        } else {
          _this4.tokenExpirationFailedCallback({
            'error': "Token cannot be refreshed by KeepAlive due to service response error with HTTP status='".concat(response.status, "'")
          });
        }
      }).catch(function (err) {
        console.error("Error occured while refreshing token.", err);
        _this4.tokenExpirationFailedCallback({
          'error': "Token cannot be refreshed by KeepAlive due to service response error."
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var divStyle = {
        position: 'fixed',
        top: '0px',
        left: '0px',
        width: '10px',
        height: '10px',
        cursor: 'pointer',
        zIndex: '1001'
      };
      // const canvasStyle = {
      //   position: 'fixed', top: '0px', left: '0px', zIndex: '1000',
      // };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: divStyle,
        onClick: function onClick(event) {
          return _this5.showError(event);
        },
        role: "presentation"
      }), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.globalError_showPopup,
        type: ModalDialog.types.okOnly,
        onOkClick: function onOkClick() {
          return _this5.hideError();
        },
        okLabel: this.translations.okLabel,
        blurElementID: "wrapper",
        style: {
          content: {
            height: '',
            width: ''
          }
        }
      }, /*#__PURE__*/React.createElement("h5", null, this.translations.mainText), /*#__PURE__*/React.createElement("p", null, "CorrelationId: ", /*#__PURE__*/React.createElement("strong", null, this.state.globalError_error.correlationId)), this.state.globalError_error && /*#__PURE__*/React.createElement(ErrorDetails, {
        exception: this.state.globalError_error
      })), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.sessionExpired,
        type: ModalDialog.types.okOnly,
        onOkClick: function onOkClick() {
          return _this5.sessionExpiredClicked();
        },
        okLabel: this.translations.sessionExpiredButtonText,
        blurElementID: "wrapper",
        style: {
          content: {
            height: '',
            width: ''
          }
        }
      }, /*#__PURE__*/React.createElement("h5", null, this.translations.sessionExpiredTitle), /*#__PURE__*/React.createElement("p", null, this.translations.sessionExpiredText)));
    }
  }]);
}(React.Component);